import { EPlaceholderDisabledActionType, TDisablePlaceholder } from './types';

export function disablePlaceholder(): TDisablePlaceholder {
  return {
    type: EPlaceholderDisabledActionType.DisablePlaceholder,
    payload: undefined,
  };
}
